import { h, Component } from 'preact';
import dlv from 'dlv';

import { configure } from '../../../config';

import Error from '../error';
import { Desktop } from './device/desktop.js';
import { Tablet } from './device/tablet.js';
import { Phone } from './device/phone.js';

import { COMMON_CONFIGS, setTheme } from '../../../lib/page';
import { getPageConfig, getDeviceTemplate, isDesktop } from '../../../lib/device';
import { initializeTaboolaJs, finalizeTaboolaJs } from '../../pieces/taboola-js';
import { trackPageLoad } from '../../../lib/tracking';

import { TrackingProvider, trackingProvider, DIMENSION } from '@cube/track';
import { deviceVariance } from '@cube/blocks';


@trackingProvider({
	[DIMENSION.componentpath]: 'VerticalPage'
})
@configure({
	...COMMON_CONFIGS,
	pageConfig: 'singleCube.pages.vertical',
	browseCategories: 'singleCube.browseCategories',
	verticalCategories: 'singleCube.verticalCategories',
	clientDisplayName: 'clientDisplayName'
})
@deviceVariance()
export default class Vertical extends Component {

	processPageInformation = ({ category, verticalCategories, ...props }) => {
		let categoryConfig = verticalCategories[category.toLowerCase()];
		if (!categoryConfig) {
			this.setState({
				error: true
			});
			return;
		}

		this.setState({ categoryConfig });
	};

	componentWillMount() {
		let device = this.props.device,
			pageConfig = getPageConfig(this.props.pageConfig, device);
		this.setState({ pageConfig, Device: getDeviceTemplate({ device, Desktop, Tablet, Phone }) });

		setTheme(pageConfig);
		this.processPageInformation(this.props);

		if (isDesktop(device)) {
			initializeTaboolaJs({ category: 'auto' });
		}
	}

	componentDidMount() {
		if (isDesktop(this.props.device)) {
			finalizeTaboolaJs();
		}
		trackPageLoad(this.context);
	}

	render({ browseCategories, ...props }, { Device, pageConfig, categoryConfig, error }) {

		if (error) return ( <Error /> );

		let mainCategory = dlv(categoryConfig, 'mainCategory');

		return (
			<TrackingProvider {...{ [DIMENSION.componentpath]: dlv(categoryConfig, 'title') }}>
				<Device
					categoryConfig={categoryConfig}
					browseCategories={browseCategories}
					mainCategory={mainCategory}
					{...props}
					pageConfig={pageConfig}
				/>
			</TrackingProvider>
		);
	}
}
